/* global $, jQuery */
// CUSTOM JS
// Utilizes gulp-include
// Reference docs for include syntax: https://www.npmjs.com/package/gulp-include
// =============================================================================


// FRAMEWORK - BOOTSTRAP 5.3.8
// -----------------------------------------------------------------------------

// UTILITIES - required for most plugins
// bootstrap.bundle.min.js includes Popper.js, so no separate import needed
import '../../source/vendor/bootstrap-5.3.8/dist/js/bootstrap.bundle.min.js'


// VENDOR FILES
// -----------------------------------------------------------------------------

import '../vendor/owlcarousel/dist/owl.carousel.min.js'


// CUSTOM CODE
// -----------------------------------------------------------------------------

jQuery(function(){

    /**
     * Video Controls
     */
    var iframe = document.querySelectorAll('iframe');
    $.each(iframe, MakeOverlayVideoPlay);

    function MakeOverlayVideoPlay() {
        $(document).on('click touchstart', '.video-wrapper', function() {
            var $this = $(this);
            var imgOver = $this.find('figure');
            var iFrmID = $this.data('iframe-id');
            var iFrmSrc = $('#' + iFrmID).attr('src');
            var iFrm, newSrc;

            // Remove image overlay
            $(this).find('.intent-icon').hide();
            imgOver.fadeOut();

            // YouTube controls
            if (iFrmSrc.indexOf('youtu') !== -1) {
                iFrm = $('#' + iFrmID).clone(true);
                newSrc = iFrmSrc;
                $this.find('.video-ratio').empty().html(iFrm.attr('src', newSrc.replace('&rel=0&', '&rel=0&autoplay=1&')));
            }
            // Vimeo Controls
            else if (iFrmSrc.indexOf('vimeo') !== -1) {
                iFrm = $('#' + iFrmID).clone(true);
                newSrc = iFrmSrc;
                $this.find('.video-ratio').empty().html(iFrm.attr('src', newSrc.replace('&api=1&', '&api=10&autoplay=1&')));
            }
        });
    }
});

$(document).ready(function(){

    var heroCarousel = $('.hero-carousel').owlCarousel({
        // animateOut: 'slideOutDown',
        // animateIn: 'flipInX',
        loop: true,
        nav: false,
        items: 1,
        autoplayHoverPause: true,
        mouseDrag: true,
        dotsContainer: '.hero-thumbs',
        responsive: {
            0: {
                autoWidth: true,
                center: true,
                margin: 15
            },
            991: {
                autoWidth: false,
                margin: 0,
                autoplay: true
            }
        }
    });

    $('.hero-thumb').click(function(e) {
        heroCarousel.trigger('to.owl.carousel', [$(this).index(), 300]);
        heroCarousel.trigger('stop.owl.autoplay');
        e.preventDefault();
    });

    $(document).on('click', '.hero-carousel-nav-next', function(e) {
        heroCarousel.trigger('next.owl.carousel');
        heroCarousel.trigger('stop.owl.autoplay');
        e.preventDefault();
    });
    $(document).on('click', '.hero-carousel-nav-prev', function(e) {
        heroCarousel.trigger('prev.owl.carousel');
        heroCarousel.trigger('stop.owl.autoplay');
        e.preventDefault();
    });

    // Ensure .carousel elements have .owl-carousel class
    $('.carousel').not('.owl-carousel').addClass('owl-carousel');

    $('.carousel').owlCarousel({
        loop: true,
        dots: false,
        nav: true,
        navText: ['<img src=\'/wp-content/themes/hca-mag-child/assets/static/img/chevron-left.svg\'>','<img src=\'/wp-content/themes/hca-mag-child/assets/static/img/chevron-right.svg\'>'],
        items: 1,
        autoplayHoverPause: true
    });

    $('.flyout-button').click(function(){
        $(this).parent().toggleClass('open');
    });

    $('.connect-carousel').owlCarousel({
        autoplay: false,
        loop: true,
        nav: false,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 2,
                margin: 20,
                autoWidth: true
            },

            480: {
                items: 2,
                margin: 20
            },

            991: {
                items: 3,
                margin: 40,
                loop: true
            },

            1200: {
                items: 3,
                dots: false,
                loop: false,
                mouseDrag: false,
                nav: false
            }
        }
    });

    // make last breadcrumb item an h1
    $('.breadcrumb_last').wrap('<h1></h1>');

    var stickyTop = $('.menubar').offset().top;

    $(window).scroll(function() {
        var windowTop = $(window).scrollTop();

        if (stickyTop < windowTop) {
            $('body').addClass('menubar-sticky');
        } else {
            $('body').removeClass('menubar-sticky');
        }
    });

    // ADA support for home hero carousel, locks down all slides except current
    // prevents confusing screenreader readout to focus context
    // prevents link jumping breaking the carousel layout
    function homeHeroADA() {
        $('.hero-carousel .owl-item').attr('aria-hidden', 'true');
        $('.hero-carousel .owl-item.active').removeAttr('aria-hidden', 'true');
        $('.hero-carousel a').attr('tabindex', '-1');
        $('.hero-carousel .owl-item.active a').attr('tabindex', '0');
    }

    homeHeroADA();

    // Rerun lockdown when slide transitions
    heroCarousel.on('translated.owl.carousel', function(event) {
        homeHeroADA();
    });

    // prevent hidden menu items from being tab accessible
    var mobileMenu = $('.mobile-menu');
    var menuitems = $(mobileMenu).find('a');

    // preset mobile menu tabindex
    if($(mobileMenu).hasClass('open')){
        menuitems.attr('tabindex', '0');
    } else {
        menuitems.attr('tabindex', '-1');
    }

    // preset mobile menu to hide when offscreen
    $(mobileMenu).addClass('closed').attr('aria-hidden', 'true').attr('aria-expanded', 'false');

    // control mobile menu and add ada attributes
    $('.mobile-off-canvas-trigger').click(function(){
        $('body').toggleClass('mobile-off-canvas-open');
        if($(mobileMenu).hasClass('closed')) {
            $(mobileMenu).addClass('open')
                .removeClass('closed')
                .attr('aria-expanded', 'true')
                .removeAttr('aria-hidden');
            $(mobileMenu).find('a').attr('tabindex', '0');
        } else {
            $(mobileMenu).removeClass('open')
                .addClass('closed')
                .attr('aria-expanded', 'false')
                .attr('aria-hidden', 'true');
            $(mobileMenu).find('a').attr('tabindex', '-1');
        }
    });

    // change parent items to hover instead of click
    $('.menubar-refresh .dropdown-toggle').attr('data-bs-toggle', '').attr('href', '/');

    $('.mobile-search-trigger').click(function(){
        $(this).toggleClass('mobile-search-trigger-open').parent().find('.headerbar-search').fadeToggle(300);
        $(this).parent().find('#searchMagazine').focus();
    });

    $('.card-text').matchHeight();

    $('.link-list-expand .link-list-trigger').click(function(){
        $(this).parents('.link-list-standard').addClass('expanded');
    });

    $('.link-list-collapse .link-list-trigger').click(function(){
        $(this).parents('.link-list-standard').removeClass('expanded');
    });

    //Put new JS before this?
    if($('.ita-link').length){
        var jumpTo = $('.ita-link').offset().top;
        var menubarHeight = $('.menubar').height();
        var resourcesOffset = $('.resources').offset().top;
        var resourceHeight = $('.resources').height();
        $(window).scroll(function(){
            if($(window).scrollTop() > (jumpTo + menubarHeight) && $(window).scrollTop() < (resourcesOffset + menubarHeight + resourceHeight)){
                $('.ita-link').addClass('ita-link-sticky');
            }
            else {
                $('.ita-link').removeClass('ita-link-sticky');
            }
        });
    }

    if($('.image-gallery').length){
        $('.image-gallery').masonry({
            // options
            itemSelector: '.item',
            columnWidth: 200
        });
    }
});



// Navigate to new magazine page on select change
jQuery('#past_magazines').on('change', function(){
    var val = jQuery(this).val();
    if( val.length ) {
        window.location = val;
    }
});

// Add bootstrap popover
jQuery(function () {
    jQuery('[data-bs-toggle="popover"]').popover();
});

// PaceCore Save For Later Overrides
jQuery(function() {
    var cnt = 0;
    var listItems = jQuery(document).find('.bookmarks-list-item');
    jQuery.each(listItems, function(i,v){
        if( jQuery(v).id === 'save-for-later-list-link' ||
            jQuery(v).text() === 'You have no saved bookmarks' ||
            jQuery(v).hasClass('js-default-li') ) return;
        cnt = cnt + 1;
    });
    // Update the number of bookmarks on page load
    var pi_bookmarks = JSON.parse(localStorage.getItem('bookmarks'));
    if(jQuery('.bookmark-count').length){
        if(pi_bookmarks !== null){
            jQuery('.bookmark-count').text(pi_bookmarks.length);
        }
    }
});
